// import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
// import sourceflowEnums from "@/sourceflow.enums";

// import { router } from "@/routes";


// export { default } from 'pages/resources'
import { Collection, Global } from "@sourceflow-uk/sourceflow-sdk";
import { SourceFlowHead } from "@sourceflow-uk/sourceflow-head";
import metaObject from "@/.sourceflow/metadata.json";
import sourceflowEnums from "@/sourceflow.enums";
import ReadyCTABanner from "components/ReadyCTABanner";
import SubBanner from "@/components/SubBanner";
import React, { useState, useEffect } from "react";
import PostFilters from "@/components/Shared/PostFilters";

import { router } from "@/routes";
import { useLocale } from "@/hooks/useLocale";
import { useRouter } from 'next/router';

/**
 *
 * @param global
 * @param meta
 * @returns {JSX.Element}
 * @constructor
 */

function getSlugFromPathname(pathname) {
    const segments = pathname.split('/').filter(Boolean);
    const slug = segments.pop();
    return slug.charAt(0).toUpperCase() + slug.slice(1);
}

export default function Resources({
    global,
    meta,
    blogs,
    blog_category,
    blog_tags
}) {
    const locale = useLocale();
    const router = useRouter();

    const { pathname } = useRouter();
    const slug = getSlugFromPathname(pathname);


    return (
        <>
            <SourceFlowHead
                metaObject={metaObject}
                title={meta.title}
                description={meta.description}
                canonical={meta.canonical}
            />
            <div className="bg-light-white">
                <SubBanner
                    global={global}
                    pathPrefix={`${slug}.resources.page.sub_banner`}
                    heading={`${slug}`}
                    content={<p>Amet eget a mauris quis dignissim lacus lectus nec. Suspendisse</p>}
                    breadcrumb_title={<><span>Resources</span><span className="active">{slug}</span></>}
                    // wave_color={`light-grey`}
                    className={`resources-page pt-5`}
                    waveIcon={false}
                />
                <PostFilters
                    global={global}
                    pathPrefix={`${slug}.resources.page.post_filters`}
                    post={blog_category}
                    post2={blog_tags}
                    origin_post={blogs}
                    pagePrefix={`/`}
                    pagePrefixTag={`${slug == "Blog" ? "/blog" :
                        slug == "Events" ? "/events" :
                            slug == "Downloads" ? "/downloads" :
                                slug == "Reviews" ? "/reviews" : ""}/tags/`}
                // cardPrefix={`${slug == "Blog" ? "/blog/" :
                //     slug == "Events" ? "/events/" :
                //         slug == "Downloads" ? "/downloads/" :
                //             slug == "Reviews" ? "/reviews/" : ""}`}
                />
                <div className="my-5"></div>
                <ReadyCTABanner
                    global={global}
                    pathPrefix={`${slug}.resources.page.ready_cta_banner`}
                />
            </div>
        </>
    );
}

export async function getStaticProps() {
    const global = (await Global()).toJson();

    const blogs = (await Collection(`blog`))
        .filter(post => {
            // Blog value id
            return post?.blog_category.en.includes("97a9d871-fff6-412b-aeae-c5db0ffab697");
        })
        .orderBy(['published_date.en'], ['desc'])
        .getItems()
    const blog_tags = (await Collection(`blog_tags`)).getItems()
    const blog_category = (await Collection(`blog_category`)).getItems()

    const routerKey = "blog";

    return {
        props: {
            global,
            blogs,
            blog_category,
            blog_tags,
            meta: {
                title: "Blogs | Tradewind Recruitment",
                description: `${sourceflowEnums.seo.genericDescription}`,
                // canonical: sourceflowEnums.seo.baseURL,
                canonical: `${sourceflowEnums.seo.baseURL}${router[routerKey]["en"]}`,
                // alternate: { link: router[routerKey]["en"], lang: "en" },
            },
        },
    };
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflowtext
// https://github.com/sourceflow-uk/components/pkgs/npm/job-search